import { DialogTitle, styled } from '@mui/material';
import React from 'react';

const ADialogTitle = styled(DialogTitle)(({ theme }) => ({
    borderBottom: `1px solid ${theme.palette.divider}`,
    fontSize: '1.375rem',
    fontWeight: 700,
    textAlign: 'center',
    alignSelf: 'center',
    padding: theme.spacing(2),
    
    width: 'calc(95% - 24px)',
    maxWidth: '100%',
    
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.15rem',
      padding: theme.spacing(1.5),
    },
    
    '& + .MuiIconButton-root': {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
    },
  }));

const AppDialogTitle = (props: IDialogTitleProps) => {
    return <ADialogTitle>{props.title}</ADialogTitle>;
};

export { AppDialogTitle };
